import { Component, OnInit, ViewChild } from '@angular/core';
import { Popup } from 'ng2-opd-popup';
import Swal from 'sweetalert2'
import { Router } from '@angular/router';
import { CMSService } from '../../services/cms-service';

declare var toastr: any;
declare var mdtoast: any;
declare var $;
var success_message = mdtoast("Opération effectué avec succès. En attante de validation par le Médecin", { duration: 5000, init: true, type: mdtoast.SUCCESS });
var error_message = mdtoast('Opération non effectué.', { duration: 5000, init: true, type: mdtoast.ERROR });
var info_message = mdtoast('Opération non effectué. Ce donnée est en cours d\'utilisation.', { duration: 5000, init: true, type: mdtoast.INFO });

@Component({
  selector: 'app-bibliotheque-virtuelle',
  templateUrl: './bibliotheque-virtuelle.component.html',
  styleUrls: ['./bibliotheque-virtuelle.component.scss']
})
export class BibliothequeVirtuelleComponent implements OnInit {

  pdfSrc2: string = "assets/file/bibliotheque virtu/Autre code de déontologie des médecins.pdf";
  pdfSrc3: string = "assets/file/bibliotheque virtu/Autre code de déontologie.pdf";
  pdfSrc4: string = "assets/file/bibliotheque virtu/Neuropsychology.pdf";
  mode_lois : number = 1;
  mode_fichier: number = 1;
  mode_type: number = 1;
  @ViewChild('popup5') popup5: Popup;
  infoBiblio: any;
  
  constructor(private router: Router,public cmsService: CMSService, ) { }

  ngOnInit() {
    this.getBiblio();
  }


  getBiblio() {
    this.cmsService.getBibliotheque()
      .subscribe(data => {
        this.infoBiblio = data
      },
        err => {
          console.log(err);
        })
  }

  rechercheLivre(mcl){
    if(mcl==""){
      this.getBiblio();
    }else {
      this.cmsService.getBibliothequeParmocle(mcl)
      .subscribe(data => {
        this.infoBiblio = data
      },
        err => {
          console.log(err);
        })
    }
    
  }

  details(id_text:any){  
    this.router.navigate(['detail_biblio/'+id_text]);    
  }


  open() {
    this.popup5.options = {    
      cancleBtnClass: "btn btn-default",
      confirmBtnClass: "btn btn-success",
      color: "#A0DE4F",
      showButtons: true,
      animationDuration: 1.5,
      header: "Ajouter livre",
      widthProsentage: 38,
      animation: "fadeInRight",
      confirmBtnContent: "Ajouter",
      cancleBtnContent: "Fermer",
    }

    this.popup5.show(this.popup5.options);
  }

  AjouterLivre(){

  }


  modiflivre(){
    this.open();
  }

 
  return(){
    this.mode_lois = 1;
  }
}
  